import React from 'react'

const Map = () => {
  return (
    <div>
        <h2 className='tituloMap'>Our Concierge's Picks</h2>

        <div className='mapa'>
          <a href="https://www.google.com/maps/d/u/0/edit?mid=1nnBsL8jvSiZbWANTmIWOOm8raCYCCPU&usp=sharing" rel="noreferrer" target='_blank'>
            <img src="/fotos/mapaNegro.jpg" alt="" />
          </a>
        </div>

        <p className='textoMapa'>We handpicked the best places in Palermo and around: bars, restaurants and shopping<br></br> Click on the map to explore</p>

  
    </div>
  )
}

export default Map